module.exports = __webpack_public_path__ + "static/media/imgop_Systems.acb4612d.webp";